export default {
  install(Vue, options) {
    const add = require("date-fns/add/index.js");
    const format = require("date-fns/format/index.js");

    const defaultOptions = {
      DATE_FORMAT: process.env.VUE_APP_DATE_FORMAT,
      DATE_TIME_FORMAT: process.env.VUE_APP_DATE_TIME_FORMAT
    };

    // merge default options with arg options
    let userOptions = { ...defaultOptions, ...options };

    Vue.prototype.$modifyDateByDays = function(date, days) {
      let result = add(new Date(date), { days: days });
      return result;
    };

    Vue.prototype.$formatDate = function(date) {
      return format(new Date(date), userOptions.DATE_FORMAT);
    };

    Vue.prototype.$formatDateTime = function(date) {
      return format(new Date(date), userOptions.DATE_TIME_FORMAT);
    };

    Vue.prototype.$formatDateToSQL = function(date) {
      var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();
      if (month.length < 2) 
          month = '0' + month;
      if (day.length < 2) 
          day = '0' + day;
      return [year, month, day].join('-');
    }
  }
};
